import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActions,
  Grid,
  Button,
  Box,
  Stack,
  Skeleton,
} from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProductById } from "../../../Redux/ProductRedux";
import { getAllProducts } from "../../../Redux/ProductRedux.js";
import StarRatings from "react-star-ratings";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
const BASE_URL = process.env.REACT_APP_API_URL;

const cardStyles = {
  card: {
    boxShadow: "0px 2px 4px 2px rgba(0, 0, 0, 0.1)",
    padding: "8px",
    marginBottom: "16px",
    pointer: "cursor",
    "&:hover": {
      boxShadow: "0 6px 15px rgba(0, 0, 0, 0.3)",
    },
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  media: {
    height: "250px",
    objectFit: "cover",
    cursor: "pointer",
  },
  content: {
    flexGrow: 1,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  actions: {
    paddingTop: "8px",
    justifyContent: "space-between",
  },
};

function ProductCards({ sectionName, allProducts, currentProducts }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  const handleCardClick = (product) => {
    const productId = product._id;
    dispatch(getProductById(productId));
    navigate(`/productDetails/${productId}`, { state: { product } });
  };

  useEffect(() => {
    dispatch(getAllProducts())
      .catch((error) => {
        console.error("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  const productsToDisplay =
    sectionName === "home" ? allProducts : currentProducts;

  return (
    <>
      {loading ? (
        <div className="row">
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
          <div className="col-3">
            <Stack spacing={1}>
              <Skeleton variant="rounded" height={200} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
              <Skeleton variant="text" sx={{ fontSize: ".7rem" }} />
            </Stack>
          </div>
        </div>
      ) : (
        <Grid container spacing={2}>
          {productsToDisplay
            .filter((product, index) =>
              sectionName === "home" ? index < 6 : true
            )
            .map((product) => (
              <Grid
                item
                xs={12}
                sm={4}
                md={sectionName === "home" ? 2 : 3}
                lg={sectionName === "home" ? 2 : 3}
                key={product._id}
              >
                <Card sx={cardStyles.card}>
                  <CardMedia
                    component="img"
                    sx={cardStyles.media}
                    image={`${BASE_URL}/assets/images/products/${product.images[0]?.image}`}
                    alt={product.productName}
                    onClick={() => handleCardClick(product)}
                  />
                  <CardContent sx={cardStyles.content}>
                    <Typography
                      variant="h6"
                      component="div"
                      className="card-title"
                      onClick={() => handleCardClick(product)}
                    >
                      {product.productName}
                    </Typography>

                    <Box
                      className=""
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mt={1}
                    >
                      {/* Rating on top */}
                      <StarRatings
                        rating={Number(product.rating) || 0}
                        starRatedColor="gold"
                        numberOfStars={5}
                        starDimension="16px"
                        starSpacing="2px"
                        name="rating"
                      />
                      <Box mt={0.5} display="flex" alignItems="center">
                        <CurrencyRupeeIcon
                          fontSize="small"
                          sx={{
                            verticalAlign: "middle",
                            color: "text.primary",
                          }}
                        />
                        <Typography variant="h5" fontWeight={600} ml={0.5}>
                          {product.priceAndQuantity &&
                          product.priceAndQuantity.length > 0
                            ? Math.min(
                                ...product.priceAndQuantity.map(
                                  (item) => item.price
                                )
                              ).toFixed(2)
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>

                  <CardActions sx={cardStyles.actions}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Button
                          startIcon={<ShoppingBagIcon />}
                          fullWidth
                          onClick={() => handleCardClick(product)}
                          variant="contained"
                          sx={{
                            backgroundColor: "var(--primary-color)",
                            color: "#fff",
                            "&:hover": {
                              backgroundColor: "var(--primary-color)",
                            },
                          }}
                        >
                          Buy Now
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            ))}
        </Grid>
      )}
    </>
  );
}

export default ProductCards;
